'use client';

import Link from 'next/link';
import { FC, useMemo } from 'react';
import { CategoryBubbleStoryblok } from 'storyblok-types';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { Carousel, Slide } from 'atoms/Carousel';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

interface ICategoriesBubbles {
  categories?: CategoryBubbleStoryblok[];
  categorySlug?: string;
  hasChips: boolean;
}

export const CategoriesBubbles: FC<ICategoriesBubbles> = ({
  categories = [], // categories from Storyblok in ProductGrid block
  categorySlug,
  hasChips,
}) => {
  const { header } = useSiteConfig();
  const navigationCategories = useMemo(() => {
    return (
      header?.children
        ?.flatMap((column) =>
          column.flyoutColumns?.flatMap((item) => item.items),
        )
        .find((item) => item?.url?.cached_url?.includes(categorySlug))
        ?.children?.map((item) => ({
          name: item.title,
          link: item.url?.cached_url,
        })) || []
    );
  }, [categorySlug, header?.children]);

  const bubbles = [...navigationCategories, ...categories];

  return hasChips || !bubbles.length ? null : (
    <div className={styles.root}>
      <Carousel
        className={styles.slider}
        slidesPerView={'auto'}
        spaceBetween={5}
        centerInsufficientSlides={true}
        navigation={{
          nextEl: `.${styles.swiperButtonNext}`,
          prevEl: `.${styles.swiperButtonPrev}`,
        }}
        modules={[FreeMode, Mousewheel]}
        freeMode={true}
        mousewheel={true}
      >
        {bubbles.map(({ name, link }) => (
          <Slide key={name} className={styles.slide}>
            <Link href={link} className={styles.link}>
              {name}
            </Link>
          </Slide>
        ))}
        <div className={`${styles.swiperButtonPrev}`} />
        <div className={`${styles.swiperButtonNext}`} />
      </Carousel>
    </div>
  );
};
